module.exports = __webpack_public_path__ + "static/media/icon1.ff990b89.svg";